export const SERVICES: string = 'SERVICES';
export const COMPANY: string = 'COMPANY';
export const CAREER: string = 'CAREER';
export const CONTACT_US: string = 'CONTACT_US';
export const ENGINEERING: string = 'ENGINEERING';
export const VISIT_US: string = 'VISIT_US';
export const ABOUT: string = 'ABOUT';
export const CONTACT: string = 'CONTACT';
export const HOW_TO_BUY: string = 'HOW_TO_BUY';
export const PRIVACY_POLICY: string = 'PRIVACY_POLICY';
export const CATALOG: string = 'CATALOG';
export const SHIPMENT_CONDITIONS: string = 'SHIPMENT_CONDITIONS';
export const CALCULATION_SHIPPING_COSTS: string = 'CALCULATION_SHIPPING_COSTS';
export const GENERAL_CONDITIONS: string = 'GENERAL_CONDITIONS';
export const JOB_OFFERS: string = 'JOB_OFFERS';
export const JOB_SALES_CHAUFFEUR: string = 'JOB_SALES_CHAUFFEUR';
export const JOB_REVIT_DESIGNER: string = 'JOB_REVIT_DESIGNER';
export const JOB_ACCOUNT_MANAGER: string = 'JOB_ACCOUNT_MANAGER';
export const JOB_ACCOUNT_MANAGER_LUX: string = 'JOB_ACCOUNT_MANAGER_LUX';
// Job openings: the list page and one page per offer, all edited in the CMS.
export const JOB_OFFER_CODES: string[] = [
    JOB_OFFERS,
    JOB_SALES_CHAUFFEUR,
    JOB_REVIT_DESIGNER,
    JOB_ACCOUNT_MANAGER,
    JOB_ACCOUNT_MANAGER_LUX,
];
